goog.provide('el8.app.shared.dialog.addEditDocTag');

goog.require('el8.appservice.notifier');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.base');
goog.require('el8.data.docTags');
goog.require('el8.template.app.shared.dialog.addEditDocTag');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');


el8.app.shared.dialog.addEditDocTag = (function() {
    var tag = null;
    var handleTagItemFn = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Add or Edit a Document Tag',
        autoHeight: true,
        position: 'center',
        width: 500,
        contentFn: function() { return el8.template.app.shared.dialog.addEditDocTag.content({
            'codeTypeChoices': el8.util.consts.DOC_TAG_CODE_TYPES
        }); }
    });

    var form = new el8.uiwidget.Form({
        fields: [
            {
                name: 'value',
                selector: ':input[name="value"]',
                maxLength: 100,
                validate: { required: true }
            },
            {
                name: 'description',
                selector: ':input[name="description"]',
                maxLength: 500
            },
            {
                name: 'codeType',
                selector: ':input[name="codeType"]'
            },
            {
                name: 'code',
                selector: ':input[name="code"]',
                maxLength: 50,
                mindreaderOpts: el8.appshared.mindreaderOpts.icd9Codes()
            }
        ],
        validationOpts: el8.util.validate.standardOpts,
        firstFocusSelector: '.doctag-value'
    });
    form.addSaveButton(function(_form) { submitFn(); }, true);
    form.addDiscardChangesButton(function(_form) {
        that.hide();
    });
    that.setForm(form);

    var super_show = that.show;
    that.show = function(_value, _handleTagItemFn) {
        super_show.call(that);
        if (_handleTagItemFn) { handleTagItemFn = _handleTagItemFn; }

        if (_value) { form.setVal('value',  _value); }
        that.adjustPosition();
        form.focusField('value');
        _bindTriggers(that.getContainer());
    };

    function _bindTriggers($container) {
        $container.on('change', ':input[name="codeType"]',  function(event) {
            var form = that.getForm();
            if (form.getVal('codeType') === 'ICD9') { form.getMindreader('code').enable(); }
            else { form.getMindreader('code').disable(); }
        });
    }

    function submitFn() {
        var item;
        var tagId = tag ? tag.id : null;

        if (!form.isValid()) { return; }
        if (form.getVal('code') && !form.getVal('codeType') ||
            !form.getVal('code') && form.getVal('codeType')) {
                el8.uiwidget.alert('Coded tags must have both a code and a code type.');
                return;
        }
        el8.appservice.notifier.notify('Saving tag...' );

        if (tagId) { item = el8.data.docTags.getById(tagId); }
        else { item = el8.data.docTags.create({}); }

        el8.data.docTags.saveItem(
            item.populate(form.getMapped()),
            false, // notify flag
            {
                successCb: function (item, data) {
                    el8.appservice.notifier.notify('Tag saved.');
                    that.hide();
                    if (handleTagItemFn) { handleTagItemFn(data); }
                }
            }
        );
    }

    return that;

})();
